export function fetch(uri, options) {
  if (options === void 0) {
    options = {};
  }

  var method = options.method || 'GET';
  var xhr = createXHR();
  var promise = new Promise(function (resolve, reject) {
    xhr.onerror = reject;
    xhr.ontimeout = reject;

    xhr.onload = function () {
      resolve({
        ok: xhr.status >= 200 && xhr.status < 300,
        status: xhr.status,
        statusText: xhr.statusText,
        text: function text() {
          return Promise.resolve(xhr.responseText);
        },
        json: function json() {
          return Promise.resolve(JSON.parse(xhr.responseText));
        }
      });
    };
  });
  xhr.open(method, uri);
  xhr.send(options.body);
  return promise;
}

function createXHR() {
  // @ts-ignore
  if (global.XDomainRequest) {
    // @ts-ignore
    return new XDomainRequest();
  }

  return new XMLHttpRequest();
}